/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Q4_TitleInputs */

const en_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seasons of Life`)
};

const ar_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فصول الحياة`)
};

const de_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahreszeiten des Lebens`)
};

const es_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estaciones de vida`)
};

const fr_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisons de Vie`)
};

const it_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stagioni della vita`)
};

const ja_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いのちのめぐり`)
};

const ko_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생명의 사계절`)
};

const pt_br_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estações da Vida`)
};

const ru_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сезоны жизни`)
};

const th_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฤดูกาลแห่งชีวิต`)
};

const tr_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayatın Mevsimleri`)
};

const zh_cn_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四季循环`)
};

const zh_tw_plus_q4_title = /** @type {(inputs: Plus_Q4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四季循環`)
};

/**
* | output |
* | --- |
* | "Seasons of Life" |
*
* @param {Plus_Q4_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_q4_title = /** @type {((inputs?: Plus_Q4_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Q4_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_q4_title(inputs)
	if (locale === "ar") return ar_plus_q4_title(inputs)
	if (locale === "de") return de_plus_q4_title(inputs)
	if (locale === "es") return es_plus_q4_title(inputs)
	if (locale === "fr") return fr_plus_q4_title(inputs)
	if (locale === "it") return it_plus_q4_title(inputs)
	if (locale === "ja") return ja_plus_q4_title(inputs)
	if (locale === "ko") return ko_plus_q4_title(inputs)
	if (locale === "pt_br") return pt_br_plus_q4_title(inputs)
	if (locale === "ru") return ru_plus_q4_title(inputs)
	if (locale === "th") return th_plus_q4_title(inputs)
	if (locale === "tr") return tr_plus_q4_title(inputs)
	if (locale === "zh_cn") return zh_cn_plus_q4_title(inputs)
	return zh_tw_plus_q4_title(inputs)
});